export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
  limit: number;
  offset: number;
}

/**
 * Keep list endpoints backward compatible while preserving server pagination
 * metadata whenever the backend returns a DRF limit/offset response.
 */
export const normalizePaginatedResponse = <T>(
  response: T[] | Partial<PaginatedResponse<T>>
): PaginatedResponse<T> => {
  if (Array.isArray(response)) {
    return {
      count: response.length,
      next: null,
      previous: null,
      results: response,
      limit: response.length,
      offset: 0,
    };
  }

  const results = Array.isArray(response?.results) ? response.results : [];

  return {
    count: Number(response?.count ?? results.length),
    next: response?.next ?? null,
    previous: response?.previous ?? null,
    results,
    limit: Number(response?.limit ?? results.length),
    offset: Number(response?.offset ?? 0),
  };
};
